<template>
  <div class="mx-2 d-flex">
    <svg-icon
      v-if="sort === value && order === 'asc'"
      class="icon"
      type="mdi"
      :path="up"
    />
    <svg-icon
      v-else-if="sort === value && order === 'desc'"
      class="icon"
      type="mdi"
      :path="down"
    />
    <svg-icon
      v-else
      class="icon"
      type="mdi"
      :path="right"
    />
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiChevronDown, mdiChevronRight, mdiChevronUp } from '@mdi/js';

export default {
  name: 'SortArrow',
  components: { SvgIcon },
  props: {
    value: {
      type: String,
      default: ''
    },
    sort: {
      type: String,
      default: ''
    },
    order: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      down: mdiChevronDown,
      up: mdiChevronUp,
      right: mdiChevronRight
    }
  }
}
</script>

<style scoped>
.icon:hover {
  cursor: pointer;
}
</style>
